function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

(function () {
  function init() {
    const flyData = window.fly_app_data;
    if (!flyData?.data?.frequentBoughtData) { return; }

    const pathMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (!pathMatch) { return; }
    const currentHandle = pathMatch[1].toLowerCase();

    const wrapper = document.querySelector(".custom .gfbProductBundleUpsellWrappers");
    if (!wrapper) { return; }

    if (wrapper.dataset.flyInjected) { return; }
    wrapper.dataset.flyInjected = "1";

    const bundle = flyData.data.frequentBoughtData.find((b) => {
      if (!b.isActive) return false;

      const offerBtn = b.bundleUpsellConfig?.offerButtonSettings;
      if (!offerBtn?.isEnabled) return false;
      if (!offerBtn.widgetDisplayOptions?.componentProductPages) return false;

      return (b.selectedProducts || []).some(
        (p) => p.handle?.toLowerCase() === currentHandle
      );
    });

    if (!bundle) return;

    const offerBtn = bundle.bundleUpsellConfig.offerButtonSettings;
    const bundleHandle = bundle.bundleShopifyData?.handle;
    if (!bundleHandle) return;

    const a = document.createElement("a");
    a.href = `/products/${bundleHandle}`;
    a.className = "fly-bundle-save-btn";
    a.textContent = offerBtn.buttonText || "BUNDLE & SAVE";
    wrapper.appendChild(a);
  }

  window.reinitBundleBtn = function () {
    const wrapper = document.querySelector(".custom .gfbProductBundleUpsellWrappers");
    if (wrapper) {
      wrapper.dataset.flyInjected = "";
      wrapper.innerHTML = "";
    }
    init();
  };

  let attempts = 0;
  const interval = setInterval(function () {
    attempts++;
    if (window.fly_app_data?.data?.frequentBoughtData) {
      clearInterval(interval);
      init();
    } else if (attempts >= 100) {
      clearInterval(interval);
    }
  }, 100);
})();

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = [],
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          'form',
          `${element.form.getAttribute('id')}-${uniqueKey}`,
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    if (!HTMLUpdateUtility._injectedSrcs) HTMLUpdateUtility._injectedSrcs = new Set();
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const src = oldScriptTag.getAttribute('src');
      if (src) {
        if (HTMLUpdateUtility._injectedSrcs.has(src)) return;
        HTMLUpdateUtility._injectedSrcs.add(src);
      }
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
    if (!event.currentTarget.closest('details').hasAttribute('open')) {
      document.querySelector('.header-menu-overlay').classList.add('open');
    } else {
      document.querySelector('.header-menu-overlay').classList.remove('open');
    }
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  function waitForElement(selector, callback) {
    if (document.querySelector(selector) !== null) {
      callback();
    } else {
      setTimeout(function () {
        waitForElement(selector, callback);
      }, 100);
    }
  }
  if(last.classList.contains("swiper-pagination-bullet")){
    waitForElement('.product-popup-modal__content-info .swiper-pagination', function () {
      var swipperPgination = document.querySelector(".product-popup-modal__content-info .swiper-pagination");
      var hasDisplayNone = (swipperPgination.offsetHeight === 0 && swipperPgination.offsetWidth === 0);
      if(hasDisplayNone == true){
        last = elements[elements.length - 4];
      }
    });
  }
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    
    if (event.code.toUpperCase() !== 'TAB' || (!event.shiftKey && event.code.toUpperCase() !== 'TAB')) return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();

  if (
    elementToFocus?.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus?.value
  ) {
    elementToFocus?.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true});
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      if (previousValue == 1) {
        event.preventDefault();
        const cartItems =
          this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.input.dataset.index, 0);
        return;
      }
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === 'minus'
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        'disabled',
        parseInt(value) <= parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    if (this.classList.contains('quantity-product-page')) {
      if (value < this.input.min) {
        this.input.value = this.input.min;
      }
    }

    // Find the ARIA live region element for this item
    const quantityStatus = this.querySelector('.quantity-status');

    // Announce the updated total to screen readers
    if (quantityStatus) {
      quantityStatus.textContent = `Updated total ${value}`;
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      'button:not(.ignore-close):not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)',
    ).forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary'),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if(this.mainDetailsToggle != null){
        if (
          this.mainDetailsToggle.hasAttribute('open') &&
          !this.mainDetailsToggle.contains(document.activeElement)
        )
          this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    document.body.classList.remove('overflow-hidden-tablet');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    if(detailsElement != null){
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement
        .querySelector('summary')
        .setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.model = this.querySelector('.model-country-selector');
    this.btn = this.querySelector('.country-model-button');
    this.span = this.querySelector('.close');

    this.modelOpen = this.modelOpen.bind(this);
    this.modelClose = this.modelClose.bind(this);
    this.modelOutsideClick = this.modelOutsideClick.bind(this);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`,
    );
  };

  connectedCallback() {
    if (window.innerWidth > 1280) {
      this.btn.addEventListener('click', this.modelOpen(this.btn));
    }else{
      this.btn.addEventListener('click', this.modelOpen);
    }
    this.span.addEventListener('click', this.modelClose);
    this.model.addEventListener('click', this.modelOutsideClick);
  }

  disconnectedCallback() {
    this.btn.removeEventListener('click', this.modelOpen);
    this.span.removeEventListener('click', this.modelClose);
    this.model.removeEventListener('click', this.modelOutsideClick);
  }

  modelOutsideClick(event) {
    if (event.target.closest('.modal-content')) return;
    this.modelClose();
  }

  modelOpen(opener) {
    this.openedBy = opener;
    this.model.classList.add('modal-open');
    trapFocus(this.querySelector('[role="dialog"]'), this.querySelector('[role="dialog"] .close'));
    //document.querySelector('body').classList.add('overflow-hidden');
  }

  modelClose() {
    this.model.classList.remove('modal-open');
    this.model.classList.remove('modal-open-footer');
    removeTrapFocus(this.openedBy)
    //document.querySelector('body').classList.remove('overflow-hidden');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            const sourceQty = html.querySelector(
              '.quick-order-list-container',
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`,
      ),
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', (e) => {
      
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) {
        //set modal focus
        setTimeout(function(e){
          if(modal.querySelector('.modal-video__video') != null){
            trapFocus(modal.querySelector('.modal-video__video'), modal.querySelector('.modal-video__toggle'));
          }

        },100)
        e.preventDefault();
        modal.show(button);
        
        setTimeout(() =>{
          const cartDrawer = document.querySelector('cart-drawer')
          if (cartDrawer && cartDrawer.classList.contains('active')) {
            cartDrawer.classList.remove('active');
            document.body.classList.remove('drawer-open');
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
          }
        }, 200);
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
      if(this.classList.contains("nb-video-section-mp")){
        const mobileVideoUrl = this.getAttribute('data-video-mobile');
        const desktopVideoUrl = this.getAttribute('data-video-desktop');
        const videoTag = this.querySelector(".section-video-mp source");
        if(mobileVideoUrl != "" && mobileVideoUrl != null){
          // Function to set the video source based on the screen width
          const setVideoSource = () => {
            const currentWidth = window.innerWidth;
            if (currentWidth > 744) {
              videoTag.setAttribute('src', desktopVideoUrl);
            } else {
              videoTag.setAttribute('src', mobileVideoUrl);
            }
            const videoElement = videoTag.closest('video');
            if (videoElement) {
              videoElement.load(); // Reload the video to apply the new source
            }
          };
          
          // Set initial video source
          setVideoSource();
          window.addEventListener('resize', debounce(setVideoSource, 200));
        }
        function debounce(func, wait) {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.slider
      ? this.slider.querySelectorAll('[id^="Slide-"]')
      : []
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.slider
      ? this.querySelector('button[name="previous"]')
      : null;
    this.nextButton = this.slider
      ? this.querySelector('button[name="next"]')
      : null;
    this.playPauseButton = this.querySelector('.slider-button--play-pause');
    this.progressBar = this.querySelector('.slider-progress__bar');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.playPauseButton?.addEventListener('click', this.playPause.bind(this));
    this.video = null;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  updateProgressBar() {
    if (!this.progressBar) return;
  
    const total = this.pageTotalElement 
      ? parseInt(this.pageTotalElement.textContent) 
      : this.totalPages;
      
    if (total > 0) {
      const progress = (this.currentPage / total) * 100;
      this.progressBar.style.width = `${progress}%`;
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    // Prepend a '0' if the number is less than 10

    if (this.currentPageElement) {
      this.currentPageElement.textContent = this.currentPage < 10 ? `0${this.currentPage}` : this.currentPage;
    }

    this.updateProgressBar();

    if (
      this.sliderItems[this.currentPage - 1] && this.sliderItems[this.currentPage - 1].classList.contains('video-media')
    ) {
      !this.video && this.playPauseButton?.click();
      this.playPauseButton?.classList.add('playing');
      this.playPauseButton?.classList.add('visible');
      if (this.video && this.video.paused) this.video.play();
    } else {
      this.video && this.video.pause();
      this.playPauseButton?.classList.remove('visible');
      this.playPauseButton?.classList.remove('playing');
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  playPause() {
    const currentSlide = this.sliderItems[this.currentPage - 1];
    
    // Check if it's a video slide
    if (!currentSlide.classList.contains('video-media') && 
        !currentSlide.querySelector('.video-media') &&
        !currentSlide.querySelector('video')) return;
  
    // Try to find video - could be direct child or inside video-media div
    let video = currentSlide.querySelector('video');
    
    // If no video found, check for deferred-media (fallback for old structure)
    if (!video) {
      const playButton = currentSlide.querySelector('deferred-media button');
      if (playButton) {
        playButton.click();
        // Wait a bit for video to be injected
        setTimeout(() => {
          this.video = currentSlide.querySelector('video');
          if (this.video) {
            this.video.muted = true;
            this.video.play();
          }
          this.playPauseButton.classList.add('playing');
          this.playPauseButton.setAttribute('aria-label', 'Pause video');
        }, 100);
        return;
      }
    }
  
    // Video exists - toggle play/pause
    if (video) {
      this.video = video;
      if (video.paused) {
        video.muted = true;
        video.play();
        this.playPauseButton.classList.add('playing');
        this.playPauseButton.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        this.playPauseButton.classList.remove('playing');
        this.playPauseButton.setAttribute('aria-label', 'Play video');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset + 20;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.closest('.collection-list-wrapper')) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset + 150
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    }
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow != undefined) {
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    }

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    );
    if (this.sliderItemsToShow != undefined) {
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
    }

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      );
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true')
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          {once: true},
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener(
        'click',
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      document.querySelector('.play-and-pause').classList.add('active');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      document.querySelector('.play-and-pause').classList.remove('active');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  videoPlayPause() {
    // Select the currently visible slide
    const players = document.querySelector(
      '.hero-custom-slider .slideshow__slide[aria-hidden="false"].main-video-sliders',
    );
    if (players) {
      const videoTag = players.querySelector('.slideshow__media video');
      if (videoTag) {
        videoTag.currentTime = 0;
        videoTag.muted = true;
        //videoTag.play().catch(function (error) {});
      } else {
        document
          .querySelectorAll(
            '.hero-custom-slider .slideshow__slide[aria-hidden="true"] .video-section video',
          )
          .forEach((pauseVideo) => {
            //pauseVideo.pause();
          });
      }
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
    if(this.slider.querySelector('.main-video-sliders') != null && this.slider.closest('.hero-video-slider') == null){
      this.videoPlayPause();
    }
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      const videoElement = item.querySelector('video');
      const iframeElement = item.querySelector('iframe');

      if (index === this.currentPage - 1) {
        if (linkElements.length) {
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        }
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
        if (videoElement) {
          videoElement.currentTime = 0;
          videoElement.muted = true;
          if (item.querySelector('.video_mute_unmute')) {
            item.querySelector('.video_mute_unmute').classList.remove('video_unmuted');
          }
          
          //videoElement.play();
          // if (videoElement && videoElement.closest('.hero-video-slider')) {
          //   const videoButton = videoElement.nextElementSibling;
          //   if (videoButton.classList.contains('video_play_pause--paused')) {
          //     videoButton.classList.remove('video_play_pause--paused');
          //   }
          // }
        }

      } else {
        if (linkElements.length) {
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        }
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        if (videoElement) {
          //videoElement.pause();
          videoElement.currentTime = 0; // Reinicia el video
          videoElement.muted = true;
          if (item.querySelector('.video_mute_unmute')) {
            item.querySelector('.video_mute_unmute').classList.remove('video_unmuted');
          }
        }
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === 'next' && !isLastSlide) ||
      (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
    if(this.slider.querySelector('.main-video-sliders') != null && this.slider.closest('.hero-video-slider') == null){
      this.videoPlayPause();
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      if (!event.target.closest('.complete-the-look__product-container')) {
        this.updateSelectionMetadata(event);
        // Paint the add-to-cart state straight away from the variant JSON that
        // is already in the page, so the button never waits on the section fetch.
        this.applyOptimisticVariantUI();
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      } else {
        this.shopTheLookVariantChange(event.target);
      }
    });

    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );

    const preOrderAcceptInput = document.querySelector('#accepts_pre_order_product');
    const preOrderATCButtons = document.querySelectorAll('.product-pre-order');
    if (preOrderAcceptInput) {
      preOrderAcceptInput.addEventListener('change', (e) => {
        if (e.target.checked) {
          preOrderATCButtons.forEach((preorder) => {
            preorder.removeAttribute('disabled');
          });
        } else {
          preOrderATCButtons.forEach((preorder) => {
            preorder.setAttribute('disabled', true);
          });
        }
      });
    }
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber?.();
  }

  handleVariantChange(event) {
    const { sectionId, variant } = event.data;
    const productNode = this.closest('product-info');
    if (!productNode) return;

    const mySectionId = productNode.dataset.section || productNode.getAttribute('data-section');
    if (mySectionId && sectionId && mySectionId !== sectionId) return;

    if (!variant) return;

    this.applyVariantUI(productNode, variant);
  }

  getCurrentVariant(productNode, selectedVariantTitle) {
    const allVariants = this.getProductVariants(productNode);
    if (!allVariants) return undefined;
    const selectedVariant = allVariants.find(variant => variant.title === selectedVariantTitle);
    return selectedVariant;
  }

  // Parsed once per element: re-parsing product.variants on every option click
  // is a measurable cost on products with a lot of variants.
  getProductVariants(productNode) {
    if (this._productVariants === undefined) {
      const node = productNode?.querySelector('[data-product-variants]');
      try {
        this._productVariants = node ? JSON.parse(node.textContent) : null;
      } catch (e) {
        console.warn('Failed to parse product variants', e);
        this._productVariants = null;
      }
    }
    return this._productVariants;
  }

  get selectedVariantTitle() {
    return Array.from(
      this.querySelectorAll('select option[selected], fieldset input:checked'),
    )
      .map((input) => input.value)
      .join(' / ');
  }

  // Client-side variant resolution + UI update. Skipped silently when the
  // combination cannot be resolved locally (combined listing / product swap,
  // or not every option picked yet) — the section fetch still reconciles.
  applyOptimisticVariantUI() {
    const productNode = this.closest('product-info');
    if (!productNode) return;

    const variant = this.getCurrentVariant(productNode, this.selectedVariantTitle);
    if (!variant) return;

    this.applyVariantUI(productNode, variant, { optimistic: true });
  }

  checkPreOrderVariant(productNode, currentVariantId) {
    var allPreOrderVariants = productNode.querySelector(
      '[data-pre-order-variants]',
    )?.innerHTML;
    allPreOrderVariants = !!allPreOrderVariants ? JSON.parse(allPreOrderVariants) : null;
    const isPreOrder = allPreOrderVariants?.find(variant => variant.id === currentVariantId);
    const isPreOrderValue = isPreOrder ? isPreOrder.value : false;
    return isPreOrderValue;
  }

  applyVariantUI(productNode, currentVariant, { optimistic = false } = {}) {
    // Update hidden variant ID inputs
    productNode.querySelectorAll('.product-variant-id').forEach((item) => {
      item.setAttribute('value', currentVariant.id);
    });

    // Emarsys tracking — off the critical path, and only once per variant so the
    // optimistic pass and the section-fetch pass don't double-report.
    this.trackVariantView(productNode, currentVariant);

    // Hide Select buttons
    productNode.querySelectorAll('.button-select').forEach((select_button) => {
      if (select_button != null) {
        select_button.classList.remove('show');
        select_button.classList.add('hide');
      }
    });

    const stickySelectButton = document.querySelector('.sticky-select');
    const stickySelect = document.querySelector('.sticky-nav-flex');
    if (stickySelectButton != null) {
      stickySelectButton.classList.remove('show');
      stickySelectButton.classList.add('hide');
    }
    if (stickySelect != null) {
      stickySelect.classList.add('option-selected');
      stickySelect.closest('.sticky-navigation-section')?.classList.add('option-selected');
    }

    const stickySelected = document.querySelector('.sticky-nav-left .option-selected .size-selected');
    if (stickySelected) {
      const sizeValue = currentVariant.options[currentVariant.options.length - 1];
      stickySelected.textContent = `// ${sizeValue}`;
    }

    const customVariants = productNode.querySelector('.custom-product-variants');
    if (!customVariants) return;
    const addToCartText = customVariants.getAttribute('add-to-cart');
    const soldOutText = customVariants.getAttribute('sold-out-text');
    const preOrderText = customVariants.getAttribute('pre-order-text');

    // Only on the optimistic pass: .product-info-price still holds the previous
    // variant, so read the pre-rendered, already money-formatted price for this
    // variant instead. The post-fetch pass falls back to the DOM as before, so
    // the final rendering (price ranges, tier pricing) is unchanged.
    const variantPrice = optimistic
      ? customVariants
          .querySelector(`li[value="${currentVariant.id}"]`)
          ?.getAttribute('price')
      : null;

    if (currentVariant.available) {
      let isPreOrder = this.checkPreOrderVariant(productNode, currentVariant.id);
      if (isPreOrder) {
        this.showATC(productNode, stickySelectButton, preOrderText, isPreOrder, variantPrice);
      } else {
        this.showATC(productNode, stickySelectButton, addToCartText, false, variantPrice);
      }
      const btnATC = productNode.querySelector('.product-form__submit.product-main-atc');
      if (btnATC) {
        btnATC.setAttribute('data-label', btnATC.getAttribute('data-product-title') + ' - ' + currentVariant.title);
      }
    } else {
      this.hideATC(productNode, stickySelectButton, soldOutText);

      var OOSVariant =
        productNode.querySelector('[data-form-variant-id]') ||
        document.querySelector('[data-form-variant-id]');
      if (OOSVariant != null) {
        OOSVariant.setAttribute('data-form-variant-id', currentVariant.id);
      }

      document.querySelectorAll('.right-product-info .variant-option-value').forEach((variant, index) => {
        if (variant != null) {
          variant.innerText = currentVariant.options[index];
        }
      });
    }
  }

  trackVariantView(productNode, currentVariant) {
    // Static, not per-instance: updateOptionValues() swaps the whole
    // <variant-selects> node after every fetch, so an instance field would
    // reset and re-report the variant we already reported optimistically.
    if (VariantSelects._trackedVariantId === currentVariant.id) return;
    VariantSelects._trackedVariantId = currentVariant.id;

    const productCat = productNode.querySelector('[data-product-cat]')?.getAttribute('data-product-cat') || '';
    const customerEmail = productNode.querySelector('[data-customer-email]')?.getAttribute('data-customer-email') || '';

    const run = () => {
      if (typeof ScarabQueue === 'undefined') return;
      ScarabQueue.push(['view', `${currentVariant.id}`]);
      ScarabQueue.push(['category', `${productCat}`]);
      ScarabQueue.push(['displayCurrency', window.Shopify.currency.active]);
      if (customerEmail !== '') {
        ScarabQueue.push(['setEmail', `${customerEmail}`]);
      }
      ScarabQueue.push(['cart', window.cartItems != undefined ? window.cartItems : []]);
      ScarabQueue.push(['go']);
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: 1000 });
    } else {
      setTimeout(run, 0);
    }
  }

  showATC(productNode, stickySelectButton, addToCartText, isPreOrder, variantPrice) {
    productNode.querySelectorAll('.product-form__submit').forEach((item) => {
      productNode.classList.add('product-in-stock');
      if (productNode.querySelector('.product-notify-with-similar') != null) {
        productNode.querySelector('.product-notify-with-similar').classList.add('hidden');
      }
      if (stickySelectButton != null) {
        stickySelectButton.classList.add('product-in-stock');
        stickySelectButton.classList.remove('product-out-of-stock');
      }
      item.classList.remove('hidden');
      item.removeAttribute('disabled');
      item.closest('.product-form__buy-button')?.classList.remove('hidden');
      const abraPrice = productNode.querySelector('.price[data-abra-selector]');
      const normalPrice = productNode.querySelector('.product-info-price');

      if (item.querySelector('span') != null) {
        if (abraPrice) {
          const abraPriceFinal = abraPrice.querySelector('.price-range').childNodes[0].textContent.trim();
          if (!abraPriceFinal) return;
          item.querySelector('span').innerHTML = window.__showPriceAtc
            ? `${addToCartText} <span class="price-divider">// ${abraPriceFinal}</span>`
            : addToCartText;
        } else {
          const normalPriceFinal =
            variantPrice ||
            normalPrice?.querySelector('.price-range')?.childNodes[0].textContent.trim();
          if (normalPriceFinal && window.__showPriceAtc) {
            item.querySelector('span').innerHTML = `${addToCartText} <span class="price-divider">// ${normalPriceFinal}</span>`;
          } else {
            item.querySelector('span').textContent = addToCartText;
          }
        }
      }

      const preOrderCheckbox = productNode.querySelector('.pre-order-accepts');
      const preOrderMessage = document.querySelector('.pre-order-message-metafield');
      const stickyAddToCartButton = document.querySelector('.sticky-add-to-cart');
      const preOrderInputProperties = productNode.querySelector('#properties-pre-order-input');
      if (isPreOrder == true) {
        item.classList.add('product-pre-order');
        if (preOrderCheckbox.querySelector('input').checked) {
          item.removeAttribute('disabled');
        } else {
          item.setAttribute('disabled', true);
        }

        if (stickyAddToCartButton) {
          stickyAddToCartButton.classList.add('product-pre-order');
          if (preOrderCheckbox.querySelector('input').checked) {
            stickyAddToCartButton.removeAttribute('disabled');
          } else {
            stickyAddToCartButton.setAttribute('disabled', true);
          }
        }

        if (preOrderCheckbox) {
          preOrderCheckbox.classList.remove('hidden');
        }
        if (preOrderMessage) {
          preOrderMessage.classList.remove('hidden');
        }
        if (preOrderInputProperties) {
          preOrderInputProperties.removeAttribute('disabled');
        }
      } else {
        item.classList.remove('product-pre-order');
        item.removeAttribute('disabled');

        if (stickyAddToCartButton) {
          stickyAddToCartButton.classList.remove('product-pre-order');
          stickyAddToCartButton.removeAttribute('disabled');
        }

        if (preOrderCheckbox) {
          preOrderCheckbox.classList.add('hidden');
          preOrderCheckbox.querySelector('input').checked = false;
        }
        if (preOrderMessage) {
          preOrderMessage.classList.add('hidden');
        }
        if (preOrderInputProperties) {
          preOrderInputProperties.setAttribute('disabled', true);
        }
      }
    });
  }

  hideATC(productNode, stickySelectButton, soldOutText) {
    productNode.querySelectorAll('.product-form__submit').forEach((item) => {
      productNode.classList.remove('product-in-stock');
      productNode.classList.remove('product-pre-order');
      const preOrderCheckbox = productNode.querySelector('.pre-order-accepts');
      if (preOrderCheckbox) {
        preOrderCheckbox.classList.add('hidden');
        preOrderCheckbox.querySelector('input').checked = false;
      }
      const preOrderMessage = document.querySelector('.pre-order-message-metafield');
      if (preOrderMessage) {
        preOrderMessage.classList.add('hidden');
      }
      const preOrderInputProperties = productNode.querySelector('#properties-pre-order-input');
      if (preOrderInputProperties) {
        preOrderInputProperties.setAttribute('disabled', true);
      }
      if (productNode.querySelector('.product-notify-with-similar') != null) {
        productNode.querySelector('.product-notify-with-similar').classList.remove('hidden');
      }
      if (stickySelectButton != null) {
        stickySelectButton.classList.remove('product-in-stock');
        stickySelectButton.classList.add('product-out-of-stock');
        const stickyAddToCartButton = document.querySelector('.sticky-add-to-cart');
        if (stickyAddToCartButton) {
          stickySelectButton.classList.remove('product-pre-order');
        }
      }

      item.closest('.product-form__buy-button')?.classList.add('hidden');
      item.classList.add('hidden');
      item.setAttribute('disabled', true);
      if (item.querySelector('span') != null) {
        item.querySelector('span').textContent = soldOutText;
      }
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          'unset',
        );
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset',
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector('[data-selected-value]');

      if (selectedSwatchValue) {
        const genderLabel = window.genderLabel || '';
        selectedSwatchValue.innerHTML = genderLabel ? `// ${genderLabel} ${value}` : `// ${value}`;
      }

      const stickySelected = document.querySelector('.sticky-nav-left .option-selected .size-selected');
      if (selectedSwatchValue && stickySelected) {
        stickySelected.textContent = `// ${value}`;
      }
    }
  }

  shopTheLookVariantChange(target) {
    target
      .closest('.complete-the-look__product-container')
      .querySelectorAll('.button-select')
      .forEach((select_button) => {
        if (select_button != null) {
          select_button.classList.remove('show');
          select_button.classList.add('hide');
        }
      });
    target
      .closest('fieldset')
      .querySelectorAll('input')
      .forEach((i) => {
        i.removeAttribute('checked');
        i.classList.remove('active');
      });

    target.classList.add('active');

    let dataColorValue = target
      .closest('.complete-the-look__product-container')
      ?.querySelector('.data-color-value')
      .getAttribute('data-color-value');

    const values = [];
    target
      .closest('variant-selects')
      ?.querySelectorAll('fieldset')
      .forEach((item) => {
        if (!item.hasAttribute('hidden')) {
          const activeInput = item.querySelector(
            '.product-variant-options-list input.active',
          );
          if (activeInput) {
            values.push(activeInput.value);
          }
        }
      });
    const variantTitles = new Set([
      `${dataColorValue} / ${values.join(' / ')}`,
      `${values.join(' / ')} / ${dataColorValue}`,
    ]);

    target
      .closest('.complete-the-look__product-container')
      ?.querySelector('.custom-product-variants')
      .querySelectorAll('li')
      .forEach((title) => {
        if (variantTitles.has(title.getAttribute('data-title'))) {
          const addToCartText = title.parentElement.getAttribute('add-to-cart');
          const soldOutText = title.parentElement.getAttribute('sold-out-text');
          const variantId = title.getAttribute('value');
          const isAvailable = title.getAttribute('available');
          const variantPrice = title.getAttribute('price');
          const variantComparePrice = title.getAttribute('compare-price');
          target
            .closest('.complete-the-look__product-container')
            .querySelectorAll('.product-variant-id')
            .forEach((item) => {
              item.setAttribute('value', variantId);
            });

          target
            .closest('.complete-the-look__product-container')
            ?.querySelectorAll('.product-form__submit')
            .forEach((item) => {
              if (isAvailable == 'true') {
                item.classList.remove('button-disabled');
                item.removeAttribute('disabled');
                item.querySelector('span').textContent = addToCartText;
              } else {
                item.classList.add('button-disabled');
                item.setAttribute('disabled', true);
                item.querySelector('span').textContent = soldOutText;
              }
            });

          target
            .closest('.complete-the-look__product-container')
            ?.querySelectorAll('.complete-the-look__quick-add-dialog')
            .forEach((item) => {
              if (variantComparePrice) {
                item.querySelector('.price').classList.add('price--on-sale');
                const comparePriceElement = item?.querySelector(
                  '.price__sale .price-item--regular',
                );
                const regularPriceElement = item?.querySelector(
                  '.price__sale .price-item--sale',
                );
                if (regularPriceElement) {
                  regularPriceElement.textContent = variantPrice;
                }
                if (comparePriceElement) {
                  comparePriceElement.textContent = variantComparePrice;
                }
              } else {
                item.querySelector('.price').classList.remove('price--on-sale');
                const priceElement = item?.querySelector(
                  '.price__regular .price-item--regular',
                );
                if (priceElement) {
                  priceElement.textContent = variantPrice;
                }
              }
            });
        }
      });
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll('select option[selected], fieldset input:checked'),
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      {rootMargin: '0px 0px 400px 0px'},
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector('slideshow-component') &&
          this.classList.contains('complementary-products')
        ) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
          initColorSwitcher();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener(
      'storefront:signincompleted',
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({id, quantity});
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement),
    );
    const quickBulkElement =
      this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          '[min]',
          event.target.dataset.min,
        ),
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          '[max]',
          event.target.max,
        ),
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          '[step]',
          event.target.step,
        ),
      );
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

/*
 * Custom JS Codes
 */

function initColorSwitcher() {
  // Product card - color switcher
  const colorSwitchers = document.querySelectorAll(
    '.product-variant-picker-color .product-variant-color-picker-link',
  );

  if (colorSwitchers) {
    colorSwitchers.forEach((switcher) => {
      switcher.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent the button from redirecting immediately

        // Get the closest parent .grid__item element of the clicked button
        const gridItem = switcher.closest('.product-card-wrapper');

        // Update the compare price
        const newComparePrice = switcher.getAttribute('data-compare-price');
        const newPrice = switcher.getAttribute('data-price');
        if (newComparePrice) {
          gridItem.querySelector('.price').classList.add('price--on-sale');
          const comparePriceElement = gridItem?.querySelector(
            '.price__sale .price-item--regular',
          );
          const regularPriceElement = gridItem?.querySelector(
            '.price__sale .price-item--sale',
          );
          if (regularPriceElement) {
            regularPriceElement.textContent = newPrice;
          }
          if (comparePriceElement) {
            comparePriceElement.textContent = newComparePrice;
          }
        } else {
          gridItem.querySelector('.price').classList.remove('price--on-sale');
          const priceElement = gridItem?.querySelector(
            '.price__regular .price-item--regular',
          );
          if (priceElement) {
            priceElement.textContent = newPrice;
          }
        }

        // Update the product URL
        const productLinks = gridItem?.querySelectorAll('.card__heading a');
        const newProductUrl = switcher.getAttribute('data-product-url');
        if (productLinks) {
          productLinks.forEach((productLink) => {
            productLink.href = newProductUrl;
          });
        }

        // Update the primary image
        const primaryImage = gridItem?.querySelector('.card__media img');
        const newPrimaryImageUrl = switcher.getAttribute('data-primary-image');
        if (primaryImage) {
          primaryImage.src = newPrimaryImageUrl;
          primaryImage.srcset = `${newPrimaryImageUrl} 100w`;
        }

        // Update the secondary image on hover
        const secondaryImage = gridItem?.querySelector(
          '.media--hover-effect img:nth-child(2)',
        );
        const newSecondaryImageUrl = switcher.getAttribute(
          'data-secondary-image',
        );
        if (secondaryImage) {
          secondaryImage.src = newSecondaryImageUrl;
          secondaryImage.srcset = `${newSecondaryImageUrl} 100w`;
        }

        // Handle 'active' class for the clicked button
        gridItem
          .querySelectorAll('.product-variant-color-picker-link')
          .forEach((link) => {
            link.classList.remove('active');
            link.ariaSelected = null;
          });
        switcher.classList.add('active');
        switcher.ariaSelected = 'true';
      });
    });
  }
}

function earlyAccess () {
  const earlyAccessButtons = document.querySelectorAll('.early-access-button-login');
  const formEarlyAccess = document.querySelector('.form-early-access');

  if (earlyAccessButtons) {
    earlyAccessButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (formEarlyAccess) {
          formEarlyAccess.classList.remove('hidden');
        }
        
        sessionStorage.setItem("earlyAccessProductURL", window.location.pathname);
        let productTitle = button.getAttribute('data-product-title');
        if (button.classList.contains('early-access-teaser')) {
          productTitle = productTitle + ' Teaser';
        } else {
          productTitle = productTitle + ' Early';
        }
        sessionStorage.setItem('nobull-klaviyo-product-title', productTitle);
      });
    })
  }

  if (formEarlyAccess) {
    formEarlyAccess.addEventListener('submit', async function(event) {
      event.preventDefault();

      // Public identifiers come from theme settings, exposed in theme.liquid.
      const config = window.NBKlaviyo || {};
      if (!config.companyId || !config.listId) {
        console.error('[Klaviyo] Missing company or list id in theme settings.');
        return;
      }

      const productURL = formEarlyAccess.getAttribute('data-product-url');
      const emailInput = event.target.querySelector('input[name="earlyAccessEmail"]');
      const email = emailInput.value;
      const optSourceDetail = 'early-access-' + productURL;
      const sourceProductTitle = sessionStorage.getItem('nobull-klaviyo-product-title') || '';
      const submitButton = formEarlyAccess.querySelector('button.submit');

      // Guard against double submits while the request is in flight.
      if (submitButton.hasAttribute('disabled')) return;
      submitButton.setAttribute('disabled', 'disabled');

      try {
        // 1) Write profile properties, 2) subscribe to the Primary Opt-in list.
        await klaviyo.identify({
          email: email,
          opt_in_source: 'website',
          opt_source_detail: optSourceDetail,
          optin_source_register: sourceProductTitle,
        });

        const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + config.companyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: config.revision || '2025-07-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: optSourceDetail,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: config.listId } } }
            }
          })
        });

        if (!res.ok) throw new Error('Klaviyo subscription failed: ' + res.status);

        sessionStorage.setItem('nobull-klaviyo-optin_source_detail', '');
        formEarlyAccess.querySelector('.early-access-success-message').classList.remove('hidden');
        return true;
      } catch (error) {
        console.error(error);
        // Let the user retry after a failure instead of leaving the form dead.
        submitButton.removeAttribute('disabled');
      }
    })
  }

  const earlyAccessRedirect = document.querySelector('.early-access-login');
  if (earlyAccessRedirect) {
    earlyAccessRedirect.addEventListener('click', () => {
      const earlyProductTitle = earlyAccessRedirect.getAttribute('data-product-title') + ' Early';
      const earlyOptSourceDetail = 'early-access-' + earlyAccessRedirect.getAttribute('data-product-url');
      sessionStorage.setItem('nobull-klaviyo-optin_source_detail', earlyOptSourceDetail);
      sessionStorage.setItem('nobull-klaviyo-product-title', earlyProductTitle);
      sessionStorage.setItem("earlyAccessProductURL", window.location.pathname);
    })
  }

  if (window.location.pathname.includes('/login') || window.location.pathname.includes('/register')) {
    const storedURL = sessionStorage.getItem("earlyAccessProductURL");
    const loginForm = document.querySelector('form#customer_login');
    const registerForm = document.querySelector('form#create_customer');
    // if (storedURL && (loginForm || registerForm)) {
    //   const redirectInput = document.createElement('input');
    //   redirectInput.name = 'return_to';
    //   redirectInput.type = 'hidden';
    //   redirectInput.value = storedURL;
    //   if (loginForm) loginForm.appendChild(redirectInput);
    //   if (registerForm) registerForm.appendChild(redirectInput);
    // }

    document.addEventListener("shopify:customer:login", function () {
        alert("Login successful!");
    });
    
    document.addEventListener("shopify:customer:register", function () {
        alert("Registration successful!");
    });

    if (loginForm) {
      loginForm.addEventListener("submit", function () {
        sessionStorage.setItem("attemptLogin", "true");
      });
    }

    if (registerForm) {
      registerForm.addEventListener("submit", function () {
        sessionStorage.setItem("attemptLogin", "true");
      });
    }
  }

  const headerIcon = document.querySelector('.header__icon.header__icon--account');
  if (headerIcon && headerIcon.getAttribute('data-login') == 'logged') {
    sessionStorage.removeItem("earlyAccessProductURL");
    sessionStorage.removeItem('nobull-klaviyo-product-title');
    sessionStorage.removeItem("attemptLogin");
  }

  const earlyAcessNotify = document.querySelector('.early-access-notify-me');
  if (earlyAcessNotify) {
    const earlyAcessNotifySticky = document.querySelector('.sticky-early-access-notify-me');

    // The sticky button may not exist on every layout, so it is bound conditionally.
    if (earlyAcessNotifySticky) {
      earlyAcessNotifySticky.addEventListener('click', (e) => {
        e.preventDefault();
        earlyAcessNotify.click();
      })
    }

    const setLoading = (isLoading) => {
      [earlyAcessNotify, earlyAcessNotifySticky].forEach((button) => {
        if (!button) return;
        button.classList.toggle('loading', isLoading);
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      });
    };

    earlyAcessNotify.addEventListener('click', async function(event) {
      event.preventDefault();

      // Public identifiers come from theme settings, exposed in theme.liquid.
      const config = window.NBKlaviyo || {};
      if (!config.companyId || !config.listId) {
        console.error('[Klaviyo] Missing company or list id in theme settings.');
        return;
      }

      if (earlyAcessNotify.classList.contains('loading')) return;

      const email = earlyAcessNotify.getAttribute('data-email');
      const productTitle = earlyAcessNotify.getAttribute('data-product-title') + ' Teaser';

      setLoading(true);

      try {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          try {
            await window.klaviyo.identify({
              email: email,
              opt_in_source: 'website',
              opt_source_detail: 'early-access',
              optin_source_register: productTitle,
            });
          } catch (e) {
            // Property writes are secondary; the subscription itself still matters.
            console.warn('[Klaviyo] identify failed, continuing to subscriptions call:', e);
          }
        }

        const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + config.companyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: config.revision || '2025-07-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'early-access',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: config.listId } } }
            }
          })
        });

        if (!res.ok) throw new Error('Klaviyo subscription failed: ' + res.status);

        sessionStorage.setItem('nobull-klaviyo-optin_source_detail', '');
        document.querySelector('.customer-tier-message-early-access')?.classList.remove('hidden');
        return true;
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.model-country-selector');
  const currencyButton = document.querySelector('footer .country-model-button');
  var openedBy = '';
  const openModal = () => { 
    openedBy = currencyButton;
    modal.classList.add('modal-open-footer');
    if (modal) {
        //set modal focus
        setTimeout(function(e){
          if(modal.querySelector('.modal-content') != null){
            trapFocus(modal.querySelector('.modal-content'), modal.querySelector('.close'));
          }
        },100);
      }
  };

  if (currencyButton) {
    currencyButton.addEventListener('click', openModal);
      modal.addEventListener('keyup', function(event){
        if(modal.classList.contains('modal-open-footer')){
          onKeyUpEscape(modal, event, openedBy);
        }
      });
    
      //close footer modal 
      modal.querySelector('.close').addEventListener('click', function(event){
        if(modal.classList.contains('modal-open-footer')){
          closeModal(modal, openedBy);
        }
      });

      //close footer modal when clicking outside the modal content
      modal.addEventListener('click', function(event){
        if(event.target.closest('.modal-content')) return;
        if(modal.classList.contains('modal-open-footer')){
          closeModal(modal, openedBy);
        }
      });
      
  }
  
  function onKeyUpEscape(modal, event, currencyButton){
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    modal.classList.remove('modal-open-footer');
    removeTrapFocus(currencyButton)
  }
  
  function closeModal(modal, currencyButton){
    modal.classList.remove('modal-open-footer');
    removeTrapFocus(currencyButton)
  }

  const updateCountryFlag = (selectedCountry) => {
    const countrySpans = document.querySelectorAll('.country-selector-flag');

    countrySpans.forEach((span) => {
      span.classList.add('hidden');
    });

    const activeCountrySpans = document.querySelectorAll(
      `.country-${selectedCountry.toLowerCase()}`,
    );

    if (activeCountrySpans) {
      activeCountrySpans.forEach((activeSpan) => {
        activeSpan.classList.remove('hidden');
      });
    }
  };

  const countrySelector = document.querySelectorAll('.country-selector');
  if (countrySelector) {
    countrySelector.forEach(
      (selector) =>
        (selector.onchange = (event) => {
          updateCountryFlag(event.target.value);
        }),
    );
  }

  // Hide copy link from youtube videos
  document.querySelectorAll('.ytp-show-copylink-title').forEach((element) => {
    element.style.display = 'none';
  });

  // Product card - color switcher
  initColorSwitcher();

  // Save product when early access link to login
  earlyAccess();

  // Foxsell update product URL
  const foxsellBox = document.querySelectorAll('.fsb-whats-in-box__product-card');
  if (foxsellBox) {
    foxsellBox.forEach((box) => {
      const boxData = box.getAttribute('data-product');
      if (boxData) {
        const boxDataJSON = JSON.parse(boxData);
        const boxProductURL = boxDataJSON.handle;
        const boxProductTitle = box.querySelector('.fsb-whats-in-box__product-title');
        if (boxProductTitle) {
          boxProductTitle.addEventListener('click', () => window.location.href = boxProductURL);
        }
      }
    })
  }
  
});

/***** Wait for Element funtion *****/
function waitForElement(selector, callback) {
  if (document.querySelector(selector) !== null) {
    callback();
  } else {
    setTimeout(function () {
      waitForElement(selector, callback);
    }, 100);
  }
}
/***** Wait for Element funtion *****/

// Adjusting the mega menu drawer position when Shiping bar is present

waitForElement('#FreeShippingBanner', function () {
  if (window.innerWidth > 1280) {
    const freeBanner = document.querySelector('#FreeShippingBanner');
    adjustMenuHeight(freeBanner);
  }
});

function adjustMenuHeight(freeBanner) {
  if (window.innerWidth <= 1280) return;

    let announcementBanner = (freeBanner instanceof Event) 
    ? document.querySelector('#FreeShippingBanner')
    : (freeBanner || document.querySelector('#FreeShippingBanner'));   

    const header = document.querySelector('.header');
    const promoBar = document.querySelector('.promo-bar');
    const subMenus = document.querySelectorAll('.header-nav-hover-to-open');
    const announcementHeight = announcementBanner ? announcementBanner?.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;
    const promoHeight = promoBar ? promoBar.offsetHeight : 0;
    const totalHeight = announcementHeight + headerHeight + promoHeight;
    // A locked promo bar keeps the header below it instead of at the very top,
    // so the header's own bottom edge is where the menu has to start.
    const promoBarLocked = promoBar?.dataset.locked === 'true';
    const offset = promoBarLocked || header.getBoundingClientRect().top === 0 ? 0 : window.scrollY;
    const adjustedHeight = promoBarLocked
      ? Math.round(header.getBoundingClientRect().bottom)
      : offset === 0 && window.scrollY !== 0 ? headerHeight : totalHeight;

    subMenus.forEach((menu) => {
      const submenu = menu.querySelector('.header__submenu');
      const overlay = document.querySelector('.header-menu-overlay');

      if (submenu) submenu.style.top = `calc(${adjustedHeight}px - ${offset}px)`;
      if (overlay) {
        overlay.style.height = `calc(100% - ${adjustedHeight}px - ${offset}px)`;
        overlay.style.top = `calc(${adjustedHeight}px - ${offset}px)`;
      }
    });
  }

adjustMenuHeight();
document.addEventListener('scroll', debounce(adjustMenuHeight, 100));
window.addEventListener('resize', adjustMenuHeight);

// Adding and removing overflow class on header link click

document.addEventListener('click', function (e) {
  const menuToggle = e.target.closest('.header-nav-hover-to-open');
  // The desktop mega panel runs its own overlay and scroll lock in header-nav.js.
  // Letting this handler lock the body too leaves the page stuck after a hover
  // close, because only the next click anywhere would take the class back off.
  if (menuToggle?.classList.contains('nav-desktop__details')) return;
  document.body.classList.remove('overflow-hidden-desktop');

  setTimeout(function () {
    document.querySelector('.header-menu-overlay')?.classList.remove('open');
    if (menuToggle && menuToggle.hasAttribute('open')) {
      document.body.classList.add('overflow-hidden-desktop');
      document.querySelector('.header-menu-overlay')?.classList.add('open');
    }
  }, 0);
});

// Disabling focus of footer newsletter email field
const footerEmailField = document.querySelector(
  '.footer-column.footer-column--news input[type="email"]',
);

if (footerEmailField != null) {
  footerEmailField.addEventListener('mousedown', () => {
    footerEmailField.classList.add('no-focus-visible');
  });

  footerEmailField.addEventListener('blur', () => {
    footerEmailField.classList.remove('no-focus-visible');
  });
}

// class DataLayerPageViewFixer {
//   constructor(maxRetries = 200, interval = 50) {
//     this.retries = 0;
//     this.maxRetries = maxRetries;
//     this.interval = interval;
//     this.init();
//   }

//   init() {
//     if (window.dataLayer?.push) {
//       this.overridePush();
//     } else if (this.retries++ < this.maxRetries) {
//       setTimeout(() => this.init(), this.interval);
//     }
//   }

//   getPageType() {
//     const path = window.location.pathname.toLowerCase();
//     if (path === "/" || path === "") return "homepage";
//     if (path.startsWith("/products")) return "PDP";
//     if (path.startsWith("/collections")) return "PGP";
//     if (path.startsWith("/checkout")) return "checkout";
//     if (path.startsWith("/account")) return "account";
//     if (path.includes("order-confirmation")) return "order_confirmation";
//     if (path.startsWith("/blogs")) return "blog";
//     if (path.includes("event")) return "event_landing";
//     return "other";
//   }

//   overridePush() {
//     const originalPush = window.dataLayer.push.bind(window.dataLayer);
//     window.dataLayer.push = (...args) => {
//       const eventObj = args[0];
//       if (eventObj && typeof eventObj === "object") {
//         eventObj.page_type = this.getPageType();
//       }
//       return originalPush(...args);
//     };
//   }
// }

// new DataLayerPageViewFixer();
